export const VIEW_TYPE_IDS = {
    ABSOLUTE: "reporting_period",
    PERCENT: "percent_to_previous_year"
} as const;